import { LinkCellRenderer } from "@/controls/ag-grid/components/ButtonCellRenderer";
import { routeDelaysManager } from "@/setup/routes/delay.routes";
import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef } from "ag-grid-enterprise";
import moment from "moment";
import { MillAdjustment } from "../models/MillAdjustment";

function formatDecimal(value: number): string {
	if (Number.isInteger(value)) {
		return value.toString();
	}

	const fixedValue = value.toFixed(3);
	const trimmedValue = fixedValue.replace(/(\.0*|0*)$/, "");

	return trimmedValue;
}

export const useTableData = () => {
	const columnDefs: (ColDef | ColGroupDef)[] = [
		{
			headerName: "Adjustment",
			children: [
				{
					field: "Timestamp",
					headerName: "Time",
					valueGetter: (params) =>
						dxtToLocalServerTime(
							(params.data as MillAdjustment)?.Timestamp,
							"MM/dd HH:mm:ss",
						) || "",
					maxWidth: 120,
					flex: 1,
				},
				{
					field: "Stands",
					headerName: "Stands",
					editable: false,
					flex: 2,
				},
				{
					field: "OperatorName",
					headerName: "Operator",
					editable: false,
					flex: 2,
				},
				{
					field: "AdjustmentTypeName",
					headerName: "Type",
					editable: false,
					flex: 3,
					cellStyle: {
						justifyContent: "flex-start",
					},
					wrapText: true,
					autoHeight: true,
				},
				{
					field: "AdjustmentReasonName",
					headerName: "Reason",
					editable: false,
					flex: 3,
				},
				{
					field: "AdjustmentValue",
					headerName: "Value",
					maxWidth: 100,
					editable: false,
					valueGetter: (params) => {
						const value = (params.data as MillAdjustment).AdjustmentValue;
						const unit = (params.data as MillAdjustment).Unit;

						if (value === null || value === undefined) {
							return "";
						}

						const numValue = Number(value);
						const formattedValue = formatDecimal(numValue);

						return `${formattedValue} ${unit && unit !== "-" ? unit : ""}`;
					},
					flex: 1,
				},
			],
		},
		{
			headerName: "Delay",
			headerClass: "start-column",
			children: [
				{
					field: "Start",
					headerName: "Start",
					cellRenderer: (params: any) => {
						const shiftId = (params.data as MillAdjustment).ShiftId;
						const delayId = (params.data as MillAdjustment).DelayId;

						return LinkCellRenderer({
							...params,
							link: `${routeDelaysManager}/${shiftId}?assetId=12&delayId=${delayId}`,
						});
					},
					valueGetter: (params) =>
						dxtToLocalServerTime(
							(params.data as MillAdjustment)?.Start,
							"MM/dd HH:mm:ss",
						) || "",
					maxWidth: 120,
					flex: 1,
					headerClass: "start-column",
				},
				{
					field: "End",
					headerName: "End",
					valueGetter: (params) =>
						dxtToLocalServerTime(
							(params.data as MillAdjustment)?.End,
							"MM/dd HH:mm:ss",
						) || "",
					maxWidth: 120,
					flex: 1,
				},
				{
					field: "Duration",
					headerName: "Duration",
					valueFormatter: (params) => {
						if (params.value) {
							const duration = moment.duration(params.value, "seconds");
							const minutes = Math.floor(duration.asMinutes());
							const seconds = duration.seconds();
							return `${minutes}m ${seconds}s`;
						}
						return "";
					},
					editable: false,
					flex: 1,
				},
			],
		},
	];
	return { columnDefs };
};
